import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../main/main.styles';

export const ProjectModalStyles = css`
  ${MainStyles}
  .dialog-content {
    height: calc(100% - 145px);
  }

  /* Top Level Tabs (Single Project Add/Edit , Batch Upload) */

  .dialog-content zero-tabs.top-level::part(tablist) {
    background: transparent;
  }

  .vertical zero-tab {
    font-size: 13px;
    color: var(--nest-level-tab-font);
    width: 193px;
    background: transparent;
    border: none;
    box-shadow: none;
    justify-content: flex-start;
    border-left: 3px solid transparent;
    margin-right: 0;
  }

  .dialog-content .top-level zero-tab {
    width: 50%;
    margin: 0;
    background: transparent;
    border: none;
    box-shadow: none;
    font-size: 13px;
    color: var(--top-level-tab-font);
  }

  .dialog-content .top-level zero-tab[aria-selected='true'] {
    color: var(--primary-color);
    border-bottom: 1px solid var(--primary-color);
  }

  /* Second Level Tabs (Project Categories) */

  .single-project {
    position: relative;
    height: 100%;
  }

  .single-project zero-tabs {
    height: calc(100% - 35px);
  }

  .single-project::before {
    content: '';
    position: absolute;
    width: 1px;
    left: 193px;
    height: 100%;
    top: 0;
    background-color: var(--border-1);
  }

  .vertical zero-tab:hover {
    border-radius: 0;
    background: var(--button-hover-bg);
  }

  .vertical zero-tab-panel {
    padding: 16px 19px 16px 16px;
    height: 100%;
    overflow: auto;
  }

  .single-project .vertical zero-tab[aria-selected='true'] {
    color: var(--white);
    background: var(--button-hover-bg);
    border-color: var(--nested-level-tab-selected);
    border-radius: 0;
  }

  .vertical::part(tablist) {
    background-color: transparent;
    border: none;
    padding: 15px 0 40px;
  }

  .vertical::part(end) {
    position: absolute;
    z-index: 2;
    top: 295px;
    height: auto;
    background: transparent;
    border: none;
    width: 170px;
  }

  .chart-footer {
    color: var(--font-color-1);
    text-align: center;
    padding: 0 5px;
    margin-top: 0;
  }

  .completed-tab-icon {
    padding-right: 8px;
    height: 16px;
  }

  .errors-title {
    color: rgb(255 182 96 / 99%);
    text-align: left;
    font-size: 15px;
    padding: 24px 16px 0;
    margin: 0;
    line-height: 12px;
  }

  .success-title {
    color: var(--completed);
    text-align: left;
    font-size: 15px;
    padding: 24px 16px 0;
    margin: 0;
    line-height: 12px;
  }

  .confirm-text {
    color: var(--nest-level-tab-font);
    text-align: left;
    font-size: 13px;
    padding: 12px 16px 0;
    margin: 0;
    line-height: 12px;
  }

  .button-length {
    width: 233px;
  }

  .cancel-button {
    margin-right: 23px;
  }

  .file-upload-wrapper {
    margin: 16px;
  }

  .return-button {
    border: none;
    background: rgba(135, 155, 166, 0.15);
    border-radius: 4px;
    margin-right: 10px;
    height: 28px;
    min-width: auto;
  }

  .return-button:hover {
    background: rgba(135, 155, 166, 0.2);
  }
`;
